import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import ArtistFormFields from "./ArtistFormFields";
import { useCreateArtist } from "../../../hooks/useCreateArtist";
import type { ArtistDto } from "../../../api/artistsApi";

const INITIAL: ArtistDto = {
  name: "",
  description: "",
  photoLink: "",
  lieuIds: [],
};

export default function ArtistCreatePage() {
  const navigate = useNavigate();
  const [draft, setDraft] = useState<ArtistDto>(INITIAL);
  const create = useCreateArtist();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    create.mutate(draft, { onSuccess: (res) => navigate(`/admin/artists/${res.id}`) });
  };

  return (
    <form onSubmit={onSubmit}>
      <PageHeader
        title="Nouvel artiste"
        description="Ajout d'un artiste au catalogue du tenant."
        actions={
          <>
            <Button type="button" variant="ghost" onClick={() => navigate("/admin/artists")}>
              Annuler
            </Button>
            <Button type="submit" variant="primary" loading={create.isPending}>
              Créer
            </Button>
          </>
        }
      />
      <div className="bo-card">
        <ArtistFormFields value={draft} onChange={setDraft} />
      </div>
      {create.isError && <p className="bo-error-text">Erreur : {(create.error as Error)?.message}</p>}
    </form>
  );
}
